module.exports = __webpack_public_path__ + "media/legendary.5be21faa.webm";